var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React, { memo } from 'react';
import { styled } from '@web/Theme';
import { faCircleNotch } from "@fortawesome/free-solid-svg-icons";
import { Icon } from "../Icon";
export var Spinner = memo(function (props) { return (React.createElement(Wrapper, { size: props.size, alignMiddle: props.alignMiddle },
    React.createElement(Icon, { icon: faCircleNotch, color: props.color, spin: true }))); });
var Wrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  display: flex;\n  flex: none;\n  align-items: center;\n  justify-content: center;\n  font-size: ", ";\n  color: ", ";\n  margin: ", ";\n  min-width: ", ";\n  height: ", ";\n"], ["\n  position: relative;\n  display: flex;\n  flex: none;\n  align-items: center;\n  justify-content: center;\n  font-size: ", ";\n  color: ", ";\n  margin: ", ";\n  min-width: ", ";\n  height: ", ";\n"])), function (_a) {
    var size = _a.size, theme = _a.theme;
    return "" + (size && typeof size === 'number' ? size + "px" : size || theme.vars.baseFontSize);
}, function (_a) {
    var color = _a.color;
    return color || 'inherit';
}, function (_a) {
    var alignMiddle = _a.alignMiddle;
    return (alignMiddle ? 'auto' : '0') + " 0";
}, function (_a) {
    var size = _a.size, theme = _a.theme;
    return "" + (size && typeof size === 'number' ? size + "px" : size || theme.vars.baseFontSize);
}, function (_a) {
    var size = _a.size, theme = _a.theme;
    return "" + (size && typeof size === 'number' ? size + "px" : size || theme.vars.baseFontSize);
});
var templateObject_1;
